import { Button } from "@mui/material";
import MyGuideIcon from "../MinhasGuias/MyGuideIcon";
import { sxMyGuidesCard } from "../MinhasGuias/sxProps";
import './styles.css'
import { getCTE } from "../../../services/MinhasGuiasService";
import { base64toBlob } from "../../../utils/Base64ToBlob";
import { RevalidationGuideCardProps } from "../../../interfaces/props/GuiasEAutorizacoes/RevalidationGuideCardProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";

function RevalidationGuideCard(props: RevalidationGuideCardProps) {
    
    const accessibility = useAccessibility();

    const handleClick = () => {
        props.handleGuideRevalidation(props.guide.idSolic)
    }

    const handleDetails = async () => {
        props.handleLoading(true);
        const pdf = await getCTE(props.guide.idSolic);
        if(pdf !== null){
            const blob = base64toBlob(pdf.split(',')[1]);
            const blobUrl = URL.createObjectURL(blob);
            props.handleLoading(false);
            window.open(blobUrl);
        }
    }

    return (
        <div className="my-guides-card-holder" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
            <div className="my-guides-card-icon-holder">
                <MyGuideIcon/>
            </div>
            <div className="my-guides-card-info-holder">
                <span style={accessibility.textStyleAccessibility} className='my-guides-card-info'><b>Solicitante:</b> {props.guide.nomeSolicitante}</span>
                <span style={accessibility.textStyleAccessibility} className='my-guides-card-info'><b>Guia:</b> {props.guide.idSolic}</span>
                <span style={accessibility.textStyleAccessibility} className='my-guides-card-info'><b>Emissão:</b> {props.guide.dataEmissao}</span>
                <span style={accessibility.textStyleAccessibility} className='my-guides-card-info'><b>Validade:</b> {props.guide.dataValidade}</span>
                <div className="revalidation-guide-card-button-holder ">
                    <Button
                        variant="contained" 
                        size="large"
                        onClick={handleClick}
                        style={accessibility.buttonStyleAccessibility}
                        sx={sxMyGuidesCard}
                        aria-label={`revalidar guia ${props.guide.idSolic} solicitada por ${props.guide.nomeSolicitante} em ${props.guide.dataEmissao}, válida até ${props.guide.dataValidade}`}
                    >
                            <span style={accessibility.buttonTextStyleAccessibility}>
                                Revalidar guia
                            </span>
                            
                    </Button>
                    <div className=" align-items-center">
                        <button 
                            className="clean-filter-button" 
                            onClick={handleDetails} 
                            style={accessibility.textStyleAccessibility}
                            aria-label={`visualizar detalhes da guia ${props.guide.idSolic}`}
                        >
                            <u>Visualizar guia</u> <FontAwesomeIcon icon={faChevronDown} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RevalidationGuideCard;